import { cn } from '@/utils/cn'
import type { ChatEntry } from '../useAssistant'

type AssistantAnswer = NonNullable<Extract<ChatEntry, { kind: 'turn' }>['assistant']>
type Kpi = NonNullable<NonNullable<AssistantAnswer['artifacts']>['kpis']>[number]

type KpiRowProps = {
  kpis: Kpi[]
}

const VALUE_COLOR: Record<NonNullable<Kpi['status']>, string> = {
  good: 'text-emerald-600',
  warning: 'text-amber-600',
  critical: 'text-red-600',
  neutral: 'text-slate-900',
}

const TREND_COLOR: Record<NonNullable<Kpi['status']>, string> = {
  good: 'text-emerald-600',
  warning: 'text-amber-600',
  critical: 'text-red-600',
  neutral: 'text-slate-500',
}

export const KpiRow = ({ kpis }: KpiRowProps) => {
  if (kpis.length === 0) return null
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {kpis.map((kpi, idx) => {
        const status = kpi.status ?? 'neutral'
        return (
          <div
            key={`${kpi.label}-${idx}`}
            className="rounded-lg border border-[#e2e8f0] bg-[#f8fafc] px-3 py-2"
          >
            <div className="text-[11px] leading-tight font-semibold text-slate-600">
              {kpi.label}
            </div>
            <div
              className={cn('mt-1 text-[22px] leading-none font-extrabold', VALUE_COLOR[status])}
            >
              {kpi.value}
            </div>
            {kpi.trend && (
              <div className={cn('mt-1 text-[10.5px] font-semibold', TREND_COLOR[status])}>
                {kpi.trend}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
